class AccordionComponent {

  constructor(settings) {
    this.options = Object.assign({
      activeClass: 'active',
      accordionOpener: '.accordion__btn-opener',
      container: '.accordion__slide',
      toggleEvent: 'click',
      toggle: true
    }, settings)

    this.page = document.querySelector('html');
    this.accordions = this.page.querySelectorAll(this.options.container);
    this.btns = this.page.querySelectorAll(this.options.accordionOpener);

    this.btns.forEach(btn => {
      btn.addEventListener(this.options.toggleEvent, this.onButtonClick.bind(this));
    });
  }

  closeAllElements() {
    this.accordions.forEach(accordion => {
      if (accordion.classList.contains(this.options.activeClass)) {
        accordion.classList.remove(this.options.activeClass);
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    let elem =  event.target.closest(this.options.container);
    let btn = event.target;
    let heading = btn.dataset.heading;
    let video = btn.dataset.video;

    if (elem.classList.contains(this.options.activeClass)) {
      elem.classList.remove(this.options.activeClass);
    } else {
      if(this.options.toggle) {
        this.closeAllElements(elem);
      }
      elem.classList.add(this.options.activeClass);
    }

    if (heading) {
      const frame = document.querySelector('.tabs-images__image-holder .tabs-images__frame');
      const images = frame.querySelectorAll('img');
      const matchingImage = frame.querySelector(`img[data-title="${heading}"]`);
      if (matchingImage) {
        images.forEach(image => {
          image.classList.remove('active');
        })
        matchingImage.classList.add('active');
      }
    }

    if (video) {
      const parent = btn.closest(".image-with-text");

      if (parent) {
        const videos = parent.querySelectorAll(".bg-video");

        videos.forEach(v => v.classList.add("visually-hidden"));

        const matchingVideo = parent.querySelector(`.bg-video[data-video="${video}"]`);

        if (matchingVideo) {
          matchingVideo.classList.remove("visually-hidden");
        }
      }
    }
  }
}

const accordionSection = new AccordionComponent();
